import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  // Defaults reduce redundant database traffic:
  // - staleTime 5 min: dashboards e componentes que remontam não refazem query
  // - refetchOnWindowFocus false: nada de refetch ao voltar para a aba
  // - refetchOnReconnect false: idem para reconexão
  // - retry 1: erros não geram tempestade de tentativas
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60_000,
        gcTime: 30 * 60_000,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        retry: 1,
      },
    },
  });

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
  });

  return router;
};
